import { render, staticRenderFns } from "./DetailNavBar.vue?vue&type=template&id=e56e6288&scoped=true&"
import script from "./DetailNavBar.vue?vue&type=script&lang=js&"
export * from "./DetailNavBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailNavBar.vue?vue&type=style&index=0&id=e56e6288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56e6288",
  null
  
)

export default component.exports